var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2746_2600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1359 8.35198C10.6853 10.5146 2.33992 22.028 4.49592 34.0693L5.56125 40.0226L1.33325 40.756L2.07859 44.92L62.6666 34.3986L61.9212 30.236L50.1079 29.1653L49.5839 26.2386C47.4266 14.2 35.5866 6.19064 23.1359 8.35198Z",
    fill: "#FFE87C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8707 27.2321C42.2574 18.2228 33.3561 12.3014 24.0534 13.9161C19.2627 14.7481 15.2721 17.4174 12.7454 21.0388C12.639 21.191 12.5641 21.3629 12.525 21.5445C12.4858 21.726 12.4834 21.9135 12.5176 22.0961C12.5519 22.2786 12.6222 22.4525 12.7245 22.6075C12.8269 22.7625 12.9591 22.8955 13.1134 22.9988C13.7654 23.4388 14.6561 23.2761 15.1041 22.6348C17.2067 19.6214 20.5347 17.3894 24.5494 16.6921C32.3667 15.3348 39.7267 20.3134 41.0534 27.7214C41.1908 28.4881 41.9334 29.0014 42.7108 28.8654C43.4894 28.7294 44.0081 27.9988 43.8707 27.2321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3933 41.7361L6.30396 44.1841L6.30929 44.2134L7.04929 48.3467L7.10262 48.3387L8.57995 56.0001C14.8093 54.9174 19.516 51.3387 20.4426 46.0214L29.5946 44.4307L28.8493 40.2681L20.396 41.7347L20.3933 41.7361Z",
    fill: "#FADA45"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2746_2600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCost);
export default __webpack_public_path__ + "static/media/cost.fa367288.svg";
export { ForwardRef as ReactComponent };